import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
    },
    {
        path: '',
        canActivate: [authGuard],
        loadChildren: () => import('./features/features.routes').then(m => m.FEATURES_ROUTES),
    },
];
